import { TagProps, TagSizeEnum, TagVariantEnum, TagModelEnum } from './tag.type'

import { generateClasses } from './tag.constants'

const Tags = ({
  children,
  className,
  size = TagSizeEnum.medium,
  variant = TagVariantEnum.primary,
  model = TagModelEnum.fill,
  ...rest
}: TagProps) => {
  const spanClasses = generateClasses(size, variant, model, className)

  return (
    <span className={spanClasses} {...rest}>
      {children}
    </span>
  )
}

export default Tags
